export type SurvivorAnimation = "idle" | "side" | "down" | "up";

export interface SurvivorMotionFrame {
  animation: SurvivorAnimation;
  flipX: boolean;
}

export function survivorMotionFrame(
  movementX: number,
  movementY: number,
  moving: boolean,
): SurvivorMotionFrame {
  if (!moving) return { animation: "idle", flipX: false };
  if (Math.abs(movementX) >= Math.abs(movementY)) {
    return { animation: "side", flipX: movementX > 0 };
  }
  return {
    animation: movementY > 0 ? "down" : "up",
    flipX: false,
  };
}
